/** Tip de salón/mostrador — campo de cobro, no rider_tip ni ítem Varios. */

export const POS_TIP_SUGGESTED_PERCENTS = [10, 15, 20] as const;

export type PosTipIntentSource = 'guest' | 'staff';

export type PosTipIntent = {
  amount: number;
  percent: number | null;
  source: PosTipIntentSource;
};

export function roundTipMoney(value: number): number {
  if (!Number.isFinite(value) || value <= 0) return 0;
  return Math.round(value * 100) / 100;
}

export function tipAmountFromPercent(merchandiseTotal: number, percent: number): number {
  if (!Number.isFinite(merchandiseTotal) || merchandiseTotal <= 0) return 0;
  if (!Number.isFinite(percent) || percent <= 0) return 0;
  return roundTipMoney((merchandiseTotal * percent) / 100);
}

export function parseTipIntent(raw: unknown): PosTipIntent | null {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
  const row = raw as Record<string, unknown>;
  const amount = roundTipMoney(Number(row.amount ?? 0));
  const percentRaw = row.percent;
  const percent =
    percentRaw == null || percentRaw === ''
      ? null
      : Number.isFinite(Number(percentRaw))
        ? Number(percentRaw)
        : null;
  const sourceRaw = String(row.source ?? 'staff').toLowerCase();
  const source: PosTipIntentSource = sourceRaw === 'guest' ? 'guest' : 'staff';
  return { amount, percent, source };
}

export function applyTipToCheckoutTotals<T extends {
  total: number;
  totalIngresado: number;
  vuelto: number;
  saldoPendiente: number;
}>(base: T, tipAmount: number): T & { merchandiseTotal: number; tipAmount: number } {
  const tip = roundTipMoney(tipAmount);
  const merchandiseTotal = base.total;
  const total = merchandiseTotal + tip;
  const totalIngresado = base.totalIngresado;
  return {
    ...base,
    merchandiseTotal,
    tipAmount: tip,
    total,
    vuelto: roundTipMoney(Math.max(totalIngresado - total, 0)),
    saldoPendiente: roundTipMoney(Math.max(total - totalIngresado, 0)),
  };
}
